/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';


const TrackingTypeDropdown = ({
        field: { name },
        form: { setFieldValue },
        ...props
    }) => {
        
        const [trackingTypes, setTrackingTypes] = useState([])
        useEffect(()=>{
            ReadAxios({ url: 'trackingTypeMaster/'}).then((res)=>{
                res?.data?.resultSet.length > 0 && setTrackingTypes(res.data.resultSet)
            })
        },[])
        

        let options = []
        if (trackingTypes && trackingTypes.length > 0) {
            trackingTypes.map((object, index) => {
                let temp = {}
                temp.key = object.trackingTypeId
                temp.text = object.trackingType
                temp.value = object.trackingTypeId
                return options[index] = temp
            })
        }

    return (
        <Dropdown
            selection
            onChange={(value, data) => setFieldValue(name, data.value)}
            options={options}
            clearable
            {...props}
            fluid
        />

    )
}

export default TrackingTypeDropdown